import type { Firewall } from '@/entities/firewall';
import request from '@/shared/api/request';

export const createFirewall = (data: { name: string }): Promise<{ firewall: Firewall }> =>
  request({
    url: '/firewalls/',
    method: 'POST',
    data,
  });
